var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSignificantWeather01 = function SvgSignificantWeather01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 22.23,
    y1: 189.96,
    x2: 182.61,
    y2: 40.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 50.73,
    y1: 220.54,
    x2: 211.11,
    y2: 71.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.59,
    y1: 168.89,
    x2: 162.97,
    y2: 19.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 31.33,
    y1: 199.72,
    x2: 191.71,
    y2: 50.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 44.94,
    y1: 214.33,
    x2: 205.31,
    y2: 64.87,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.69,71.51c1.01-3.77,1.51-7.69,1.51-11.68,0-25.18-20.49-45.67-45.67-45.67-20.03,0-37.7,13.2-43.59,31.96-4.4-2.44-9.32-3.71-14.45-3.71-16.24,0-29.52,12.97-30.07,29.12C14.85,72.41,0,87.8,0,106.59s15.74,35.08,35.08,35.08h23.14l-18.58,26.04c-2.5,3.51-2.83,8.07-.86,11.9,1.97,3.83,5.88,6.21,10.19,6.21h102.02c4.31,0,8.21-2.38,10.19-6.21,1.97-3.83,1.65-8.39-.86-11.9l-18.58-26.04h23.17c19.34,0,35.08-15.74,35.08-35.08s-15.32-34.66-34.31-35.08ZM155.24,171.34c1.16,1.62,1.3,3.64.39,5.41-.91,1.77-2.64,2.82-4.63,2.82H48.98c-1.99,0-3.72-1.05-4.63-2.82-.91-1.77-.77-3.79.39-5.41l51.01-71.51c.99-1.39,2.54-2.18,4.24-2.18s3.25.8,4.24,2.18l51.01,71.51ZM164.92,135.42h-27.63l-27.97-39.22c-2.18-3.05-5.58-4.81-9.33-4.81h0c-3.75,0-7.15,1.75-9.33,4.81l-27.97,39.22h-27.6c-15.9,0-28.83-12.94-28.83-28.83s12.94-28.83,28.83-28.83c.33,0,.71-.02,1.04.04.94.16,1.9-.13,2.6-.77.71-.64,1.08-1.56,1.02-2.51-.04-.61-.08-1.29-.08-1.93,0-13.19,10.69-23.92,23.83-23.92,5.28,0,10.28,1.7,14.47,4.93.85.65,1.99.83,2.99.46,1.01-.37,1.76-1.24,1.97-2.3,3.77-18.16,20-31.34,38.61-31.34,21.73,0,39.42,17.68,39.42,39.42,0,4.82-.86,9.49-2.54,13.88-.39,1.02-.22,2.16.44,3.03.66.86,1.73,1.33,2.81,1.2,1.05-.12,2.15-.19,3.25-.19,15.9,0,28.83,12.94,28.83,28.83s-12.93,28.83-28.83,28.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.14,92.85c-1.29-1.15-3.27-1.03-4.41.26-1.15,1.29-1.03,3.27.26,4.42,2.6,2.31,4.09,5.62,4.09,9.08,0,.82-.08,1.65-.25,2.45-.35,1.69.74,3.34,2.44,3.69.21.04.42.06.63.06,1.45,0,2.76-1.02,3.06-2.5.25-1.21.37-2.46.37-3.7,0-5.24-2.25-10.26-6.18-13.76Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M125.76,31.16c-1.71-.24-3.29.93-3.55,2.64-.25,1.71.93,3.3,2.64,3.55,9.45,1.39,17.08,8.61,18.98,17.95.3,1.48,1.6,2.5,3.06,2.5.21,0,.42-.02.63-.06,1.69-.35,2.78-1.99,2.44-3.69-2.42-11.92-12.15-21.12-24.2-22.89Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M98.02,153.3c.49.44,1.14.66,1.93.66s1.44-.22,1.91-.66c.47-.44.73-1.02.79-1.73l1.24-22.77v-6.82c0-1.12-.38-2.08-1.12-2.84-.74-.77-1.69-1.16-2.82-1.16s-2.08.39-2.85,1.15-1.16,1.72-1.16,2.85v6.85l1.24,22.76c.05.71.33,1.28.83,1.72Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M99.95,158.51c-1.21,0-2.28.45-3.16,1.33-.88.88-1.33,1.94-1.33,3.15s.45,2.34,1.33,3.22c.88.88,1.94,1.33,3.16,1.33s2.35-.44,3.23-1.33c.88-.88,1.33-1.96,1.33-3.22s-.45-2.27-1.33-3.15c-.88-.88-1.97-1.33-3.23-1.33Z"
  })));
};
export default SvgSignificantWeather01;